import "./styles.scss";

const MentionsPage = () => {
  return (
    <div className="mentions">
      <h1>Mentions Légales</h1>
      <h3>PROPRIÉTAIRE RÉDACTEUR</h3>
      <p>
        Le présent site <a href="https://natelco.fr">https://natelco.fr</a> est
        la propriété de Natelco dont le siège social est situé:
      </p>
      <p>7 rue Jean Menans, 75019 Paris France</p>
      <p>SIRET: 818585077</p>
      <p>Code NAF: 8559A - Formation continue d'adultes</p>
      <p>Siège social: 81858507700014</p>
      <p>Tél.: 06 60 47 85 56</p>

      <h3>HÉBERGEUR</h3>
      <p>Ce site web est hébergé par Cloudflare, Inc.:</p>
      <p>
        Code APE: 6311Z - Traitement de données, hébergement et activités
        connexes
      </p>
      <p>N° TVA: FR07898260609</p>
      <p>Siège social: 101 Townsend St, 99404 San Franciso Etats-Unis</p>
      <p>
        Site internet :{" "}
        <a href="https://www.cloudflare.com">https://www.cloudflare.com</a>
      </p>

      <h3>PROPRIÉTÉS INTELLECTUELLES</h3>
      <p>
        L’ensemble des contenus diffusés sur{" "}
        <a href="https://natelco.fr">https://natelco.fr</a> est protégé par la
        législation française et internationale relative au droit d’auteur.
      </p>
      <p>
        Toute reproduction ou représentation partielle ou totale de ce site, par
        quelque procédé que ce soit, n’est permise qu’en vue d’un usage
        strictement privé. Toute autre utilisation est interdite sauf
        autorisation préalable et expresse de Natelco.
      </p>

      <h3>
        CREATION DE LIENS VERS <a href="https://natelco.fr">NATELCO.FR</a>
      </h3>
      <p>
        La création de liens hypertextes (simples ou profonds) vers le site est
        soumise à l’autorisation préalable, expresse et écrite de Natelco.
      </p>

      <p>
        Toute demande d’autorisation doit être adressée par l’intermédiaire du
        formulaire disponible sur la page contact du site.
      </p>

      <h3>LIENS EXTERNES – LIENS ALLANTS VERS D’AUTRES SITES</h3>
      <p>
        Le site <a href="https://natelco.fr">https://natelco.fr</a> peut
        contenir des liens hypertextes allant vers d’autres sites. Aucun
        engagement concernant ces autres sites n’est pris: Natelco ne serait en
        aucune façon responsable des contenus, fonctionnement et accès de
        ceux-ci.
      </p>
    </div>
  );
};

export default MentionsPage;
